import type { ShareVoiceSidebarCategory } from "@/data-access/share-of-voice/queries/shareOfVoice-sidebar-filter-queries";
import type { PeriodType } from "@/types/url-params.types";

/** Default preset window (days) when URL has no `filterDays`. */
export const DEFAULT_FILTER_DAYS = 30;

export const clearUrlParamsState = () => ({
  filterDays: DEFAULT_FILTER_DAYS,
  isCustomDaysRange: false,
  startDate: undefined,
  endDate: undefined,
  period: null as PeriodType,
  selectedFilters: new Map() as Map<ShareVoiceSidebarCategory, string[]>,
});
